import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Booking } from 'services';
import { curriculum_manager } from 'utils/constants';
import { Results } from './components';
import { Button } from '@material-ui/core';
import { CreateBookingModal } from 'components';
import moment from 'moment';

const BookingList = props => {
  let { student, slot, reload } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    if (slot) return (
      <GenericHeader
        header={`Bookings for ${slot.reference}`}
        subheader="Booking Management" {...rest}>
        <Button disabled={moment(slot.start_at).isBefore(moment())} color="primary" onClick={handleCreateOpen} variant="contained">
          {moment(slot.start_at).isBefore(moment()) ? "Past Cut-off Timing" : "Create Booking"}
        </Button>
      </GenericHeader>
    )
    if (student) return (
      <GenericHeader
        header={`Bookings for ${student.name_en}`}
        subheader="Booking Management" {...rest}>
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Create Booking
        </Button>
      </GenericHeader>
    )
    return (
      <GenericHeader
        header={"All Bookings"}
        subheader="Booking Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Booking.list}
      title="Bookings"
      name="bookings"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      CreateComp={CreateBookingModal}
      filters={{ limit: 10, offset: 0, count: 0, search: "", student: student ? student.id : null, lesson_slot: slot ? slot.id : null }}
      comp_props={{ create_comp: { slot_id: slot ? slot.id : null, student_id: student ? student.id : null, reload } }}
    />
  );
};

export default BookingList;
